<template>
  <b-form-radio-group
    :id="id"
    :name="name"
    :options="mappedOptions"
    :multiple="multiple"
    :class="{ ...selectClass, 'radio-btn-group': true }"
    :checked="value"
    @input="onChange"
    :disabled="disabled"
    button-variant="gray"
    buttons
  />
</template>

<script>
export default {
  name: 'ComplianceDocumentsCategoryButtonSelect',
  props: {
    value: [String, Array],
    id: {
      type: String,
      default: 'compliance-document-category-select',
    },
    name: {
      type: String,
      default: undefined,
    },
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
  },
  computed: {
    mappedOptions() {
      return this.options.map((option) => {
        return { text: option.label, value: option.value };
      });
    },
  },
  methods: {
    onChange(category) {
      this.$emit('input', category);
    },
  },
};
</script>
